import { Col, Row } from 'antd'
import { Input, Select } from 'components/atoms'
import { transformData } from 'hooks'
import { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAddressService } from 'services'
import styled from 'styled-components'

const StyledColInput = styled(Col)`
  margin-top: 12px;
`

interface IProps {
  onChange?: (address: Array<string>) => void
  defaultAddress?: any
  value?: any
  getStreet?: (street: string) => void
  spans?: Array<number>
  countryComponent?: ReactNode
}
const SelectAddress = ({
  onChange,
  value,
  defaultAddress,
  spans,
  countryComponent
}: IProps) => {
  const { getListProvince, getDistrictByProvince, getWardByDistrict } =
    useAddressService()
  const { transformArrayObject } = transformData()
  const { t } = useTranslation()
  const [provinces, setProvinces] = useState([])
  const [districts, setDistricts] = useState([])
  const [wards, setWards] = useState([])
  const [street, setStreet] = useState('')

  const [province, setProvince] = useState<any>(null)
  const [district, setDistrict] = useState<any>(null)
  const [ward, setWard] = useState<any>(null)

  useEffect(() => {
    handleGetListProvince()
  }, [])

  useEffect(() => {
    if (provinces) {
      const address_clinic = value || defaultAddress
      const lengthAddress = address_clinic?.length || 0
      const _province = address_clinic?.[lengthAddress - 1] || ''
      if (provinces.length > 0 && !districts.length) {
        const defaultProvin = provinces?.find(
          (pv: any) => pv.label === _province?.trim()
        )
        if (defaultProvin) handleChangeProvince(null, defaultProvin)
      }
    }
  }, [provinces])

  useEffect(() => {
    if (districts) {
      const address_clinic = value || defaultAddress
      const lengthAddress = address_clinic?.length || 0
      const _district = address_clinic?.[lengthAddress - 2] || ''
      const defaultDistrict = districts?.find(
        (dt: any) => dt.label === _district?.trim()
      )
      if (defaultDistrict) {
        handleChangeDistrict(null, defaultDistrict)
      }
    }
  }, [districts])

  useEffect(() => {
    if (wards) {
      const address_clinic = value || defaultAddress
      const lengthAddress = address_clinic?.length || 0
      const _ward = address_clinic?.[lengthAddress - 3] || ''
      const ward = wards?.find((dt: any) => dt.label === _ward?.trim())
      if (ward) {
        handleChangeWard(null, ward)
      }
    }
  }, [wards])

  useEffect(() => {
    if (value || defaultAddress) {
      const address_clinic = value || defaultAddress
      const street = address_clinic?.[0] || ''
      if (street) {
        setStreet(street)
      }
    }
  }, [value, defaultAddress])

  const handleGetListProvince = async () => {
    const response: any = await getListProvince()
    const data = transformArrayObject(response?.data, {
      label: 'name',
      value: 'code'
    })
    setProvinces(data as any)
  }

  const handleChangeProvince = async (_: any, opt: any) => {
    setProvince(opt)
    setDistrict(null)
    setWard(null)
    const response: any = await getDistrictByProvince(opt?.value)
    if (response?.data) {
      const data = transformArrayObject(response?.data, {
        label: 'name',
        value: 'code'
      })
      setDistricts(data as any)
    }
  }

  const handleChangeDistrict = async (_: any, opt: any) => {
    setDistrict(opt)
    setWard(null)
    const response: any = await getWardByDistrict(province?.value, opt?.value)
    if (response?.data) {
      const data = transformArrayObject(response?.data, {
        label: 'name',
        value: 'code'
      })
      setWards(data as any)
    }
  }

  const handleChangeWard = async (_: any, opt: any) => {
    setWard(opt)
    if (onChange) onChange(['', opt?.label, district?.label, province?.label])
  }

  const handleOnChangeStreet = (value: any) => {
    setStreet(value)
    if (!value) {
      value = ''
    }

    if (onChange)
      onChange([value, ward?.label, district?.label, province?.label])
  }

  return (
    <Row gutter={16}>
      {countryComponent}
      <Col span={spans?.[0] || 8}>
        <Select
          onChange={(value, option) => {
            handleChangeProvince(value, option)
            if (onChange) {
              setStreet('')
              onChange(['', '', '', option?.label])
            }
          }}
          options={provinces}
          showSearch
          title={t('province-city')}
          placeholder={t('select-province-city')}
          value={province}
        />
      </Col>
      <Col span={spans?.[1] || 8}>
        <Select
          showSearch
          title={t('district')}
          options={districts}
          value={district}
          placeholder={t('select-district')}
          onChange={(value, option) => {
            handleChangeDistrict(value, option)
            if (onChange) {
              setStreet('')
              onChange(['', '', option?.label, province?.label])
            }
          }}
        />
      </Col>
      <Col span={spans?.[2] || 8}>
        <Select
          showSearch
          title={t('wards')}
          options={wards}
          value={ward}
          placeholder={t('select-wards')}
          onChange={(value, option) => {
            setStreet('')
            handleChangeWard(value, option)
          }}
        />
      </Col>
      <StyledColInput span={spans?.[3] || 12} className="street-house">
        <Input
          title={t('street-house')}
          name="street-house"
          value={street}
          onChange={handleOnChangeStreet}
        />
      </StyledColInput>
    </Row>
  )
}

export default SelectAddress
